import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import KitchenNavbar from "../../Components/KitchenNavbar";
import Loading from "../../Components/Loading";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { setDivision } from "../../Redux/Action/division";
import { useNavigate } from "react-router-dom";
import ListofOrdersKitchen from "./ListofOrdersKitchen";
import ListofOrdersNotStarted from "./ListofOrdersNotStarted";
import ListOfKitchenCompleted from "./ListOfKitchenCompleted";
import Select from "react-select";

const KitchenDashboard = () => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
    const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const userState = useSelector((state) => state?.changeTheState?.user);
  const loggedInUser = userState?.emailId;
  const [userdivisionRights, setuserDivisionList] = useState([]);
  const divisionState = useSelector((state) => state.changeDivision);
  const navigate = useNavigate();
  const [departmentList, setDepartmentList] = useState([]);
  const [selDepartment, setSelDepartment] = useState("");
  const [activeTab, setActiveTab] = useState("notStarted");

  useEffect(() => {
    fetchUniqueDepartments();
    axios
      .get(`${BASEURL}/getdivisionRights?OM_USER_ACCOUNT=${loggedInUser}`)
      .then((response) => {
        console.log(response.data);
        dispatch(setDivision(response?.data[0]?.OM_USER_DIVISION));
        setuserDivisionList(response?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, []);

  const fetchUniqueDepartments = () => {
    setIsLoading(true);
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1742`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        const uniqueDepartments = [
          ...new Map(
            response?.data?.map((item) => [item.DEPARTMENT, item]),
          ).values(),
        ];
        setDepartmentList(uniqueDepartments);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(
          "Error fetching List Of Project Idss /getOrderStatus:",
          error,
        );
      });
  };

  useEffect(() => {
  if (selDepartment) {
    setActiveTab(activeTab);
  }
}, [selDepartment]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="bg-slate-100 min-h-[100vh]">
      <KitchenNavbar />
      <div className="flex justify-center font-bold text-[15px] mt-2">
        <p>Division:</p>
        <select
          onChange={(e) => {
            dispatch(setDivision(e.target.value));
          }}
          className="lg:w-[300px] w-[250px]  border-black border ml-2 mr-2 rounded"
        >
          <option>{divisionState}</option>
          {userdivisionRights.map((item) =>
            item.OM_USER_DIVISION !== divisionState ? (
              <option key={item.OM_USER_DIVISION} value={item.OM_USER_DIVISION}>
                {item.OM_USER_DIVISION}
              </option>
            ) : null,
          )}
        </select>
      </div>

      <div className="flex justify-center font-bold text-[15px] mt-2">
        <p>Department :</p>
        <Select
          onChange={(e) => {
            setSelDepartment(e.value);
          }}
          value={
            selDepartment
              ? { value: selDepartment, label: selDepartment }
              : { value: "", label: "Select Department" }
          }
          options={[
            { value: "", label: "Select Department" },
            ...departmentList?.map((item) => ({
              value: item.DEPARTMENT,
              label: item.DEPARTMENT,
            })),
          ]}
          className="lg:w-[300px] w-[250px]  border-black border ml-2 mr-2 rounded"
        ></Select>
      </div>

      {selDepartment && (
        <section className="w-full p-2">
          {/* Tabs */}
          <div className="flex border-b border-gray-300 mb-3">
            <button
              onClick={() => setActiveTab("notStarted")}
              className={`px-5 py-2 font-semibold transition-all ${activeTab === "notStarted"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500 hover:text-blue-600"
                }`}
            >
              Orders Not Started
            </button>

            <button
              onClick={() => setActiveTab("wip")}
              className={`px-5 py-2 font-semibold transition-all ${activeTab === "wip"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500 hover:text-blue-600"
                }`}
            >
              WIP Orders
            </button>

            <button
              onClick={() => setActiveTab("completed")}
              className={`px-5 py-2 font-semibold transition-all ${activeTab === "completed"
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-500 hover:text-blue-600"
                }`}
            >
              Completed
            </button>
          </div>

          {/* Tab Content */}
          <div className="w-full">
            {activeTab === "notStarted" && (
              <div className="w-full">
                <ListofOrdersNotStarted  key={`${divisionState}-${selDepartment}`} division={divisionState} department={selDepartment} />
              </div>
            )}

            {activeTab === "wip" && (
              <div className="w-full">
                <ListofOrdersKitchen  key={`${divisionState}-${selDepartment}`} division={divisionState} department={selDepartment} />
              </div>
            )}
            
            {activeTab === "completed" && (
              <div className="w-full">
                <ListOfKitchenCompleted  key={`${divisionState}-${selDepartment}`} division={divisionState} department={selDepartment} />
              </div>
            )}
          </div>
        </section>
      )}
    </div>
  );
};

export default KitchenDashboard;
